import React from 'react';
import * as M from '../Modules';
import StaticCard from '../StaticCard';

function OutlookGroup() {
  return (
    <section className="drm-final-group">
      <div className="drm-final-group-cols drm-final-group-cols--3">
        <StaticCard id="exposure-summary" label="Exposure Summary" className="drm-final-card--bare">
          <M.ExposureSummary density="md" />
        </StaticCard>
        <div className="drm-final-divider-v" />
        <StaticCard
          id="cash-timing-bands"
          label="Cash Timing Bands"
          titleInfo={<M.TileInfo info={M.TILE_INFO.cashBands} />}
          className="drm-final-card--bare"
        >
          <M.CashTimingBands density="md" />
        </StaticCard>
        <div className="drm-final-divider-v" />
        <StaticCard
          id="weekly-story"
          label="This Week"
          titleInfo={<M.TileInfo info={M.TILE_INFO.thisWeekAiSummary} />}
          className="drm-final-card--bare"
        >
          <M.WeeklyStory density="md" />
        </StaticCard>
      </div>
    </section>
  );
}

export default OutlookGroup;
